<template>
  <v-dialog v-model="show" persistent max-width="600" mobile-breakpoint="0">
    <v-card :loading="loading">
      <v-card-title>{{ $t('vmail.cfg.greeting.tts.title') }}</v-card-title>
      <v-card-text>
        <tts-form :speed="speed" :pitch="pitch"  :volumeGainDb="volumeGainDb" :textToSpeech="textToSpeech"
          :voiceType="voiceType" :textType="textType" @update-voice-type="updateVoiceType" @update-speed="updateSpeed"
          @update-pitch="updatePitch" @update-text-type="updateTextType"
          @update-text-to-speech="updateTextToSpeech" @update-volume-gain-db="updateVolumeGainDb"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="cancel" text>
          {{ $t('vmail.cfg.greeting.tts.cancel') }}
        </v-btn>
        <v-btn @click="save" color="primary" :disabled="!canSubmit" :loading="loading" text>
          {{ $t('vmail.cfg.greeting.tts.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api'
import events from 'Store/events'
import TtsForm from '@/components/text_to_speech'

export default {
  name: 'voicemails-greetings-ttsForm',
  components: { TtsForm },
  data () {
    return {
      loading: false,
      textToSpeech: '',
      speed: 1,
      pitch: 0,
      volumeGainDb: 0,
      textType: 'text',
      voiceType: 'en-US-Chirp-HD-F'
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    messageType: {
      type: String,
      required: true
    },
    voicemailBoxID: {
      type: Number,
      required: true
    },
    defaultText: {
      type: String,
      required: false
    }
  },
  created () {
    this.getTTS()
  },
  computed: {
    ttsAPIParams () {
      return {
        text_to_speech: this.textToSpeech,
        speed: this.speed,
        pitch: this.pitch,
        volume_gain_db: this.volumeGainDb,
        text_type: this.textType,
        voice_type: this.voiceType
      }
    },
    canSubmit () {
      return this.textToSpeech?.trim() !== '' && this.textType?.trim() !== '' && this.voiceType?.trim() !== ''
    }
  },
  methods: {
    updateSpeed: function (speed) { this.speed = speed },
    updatePitch: function (pitch) { this.pitch = pitch },
    updateVolumeGainDb: function (volumeGainDb) { this.volumeGainDb = volumeGainDb },
    updateTextToSpeech: function (textToSpeech) { this.textToSpeech = textToSpeech },
    updateTextType: function (textType) { this.textType = textType },
    updateVoiceType: function (voiceType) { this.voiceType = voiceType },
    cancel () {
      this.$emit('close')
    },
    getTTS () {
      API.VMGreetingTTSGet(this.messageType, this.voicemailBoxID).then(response => {
        const data = response.data
        // if not tts set, data will be null
        if (data) {
          this.textToSpeech = data.text_to_speech
          this.speed = data.speed
          this.pitch = data.pitch
          this.volumeGainDb = data.volume_gain_db
          this.textType = data.text_type
          this.voiceType = data.voice_type
        } else {
          this.textToSpeech = this.defaultText
        }
      })
    },
    save: function (ttsParams) {
      this.loading = true
      this.$emit('updating')
      API.VMGreetingTTSSet(this.messageType, this.voicemailBoxID, this.ttsAPIParams).then(response => {
        events.pubNotify({
          text: 'vmail.cfg.greeting.updated',
          args: { name: this.messageType },
          status: 'success'
        })
        this.$emit('set-audio')
      }).catch(error => {
        this.dbg(error)
        this.dbg(`Failed go get voicemail recording: ${this.messageType}`)
        const msg = error.response?.data?.message
          ? error.response.data.message
          : `Failed to save TTS for: ${this.messageType}`
        events.pubError(msg)
      }).finally(() => {
        this.loading = false
        this.$emit('updating')
        this.$emit('close')
      })
    }
  }
}
</script>

<style>
</style>
